import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
  const { lang, toggle } = useLanguage();
  const label = lang === "en" ? "العربية" : "English";
  const isArabicLabel = lang === "en"; // we're showing Arabic as the switch-to option

  return (
    <button
      onClick={toggle}
      data-testid="lang-toggle"
      aria-label="Toggle language"
      className={`inline-flex items-center gap-2 px-3 py-1.5 border border-[#F5C518]/30 hover:border-[#F5C518] hover:bg-[#F5C518]/10 text-[#F5C518] transition-all rounded-sm ${className}`}
    >
      <Globe className="w-4 h-4" />
      <span
        className={`font-body font-semibold ${
          isArabicLabel ? "text-base sm:text-lg" : "text-sm tracking-[0.15em] uppercase"
        }`}
        style={isArabicLabel ? { fontFamily: "Tajawal, sans-serif" } : {}}
      >
        {label}
      </span>
    </button>
  );
}
